export default __webpack_public_path__ + "static/media/2t.7bd2cb96.jpg";